module.exports = __webpack_public_path__ + "img/ip2.eeb7686c.png";